import axios from 'axios';

let installed = false;

function bridgeNotifications() {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (response) => {
      if (typeof window !== 'undefined'
        && window.TeamforceNotifications
        && response && response.data && typeof response.data === 'object'
        && 'ok' in response.data) {
        window.TeamforceNotifications.handleJsonResponse(response, { showError: false });
      }
      return response;
    },
    (error) => {
      if (typeof window !== 'undefined' && window.TeamforceNotifications) {
        window.TeamforceNotifications.handleJsonResponse(error.response, { showSuccess: false });
      }
      return Promise.reject(error);
    },
  );
}

bridgeNotifications();

export default bridgeNotifications;
